import { FC, ReactNode, ButtonHTMLAttributes } from 'react'
import cn from 'classnames'

import Typography from '~/components/Typography'

import styles from './Button.pcss'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	afterContent?: ReactNode
	beforeContent?: ReactNode
	size?: 'S'
	block?: boolean
	color?: 'black' | 'white'
	onClick?: () => void
	className?: string
}

const Button: FC<ButtonProps> = ({
	beforeContent,
	afterContent,
	size,
	block = false,
	color = 'white',
	type = 'button',
	onClick,
	className,
	children,
	...rest
}) => (
	<button
		type={type}
		className={cn(
			styles.button,
			block && styles.block,
			styles[color],
			size && styles[`size-${size}`],
			className
		)}
		onClick={onClick}
		{...rest}
	>
		{beforeContent}
		<Typography color="inherit">{children}</Typography>
		{afterContent}
	</button>
)

export default Button
